import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav-editor",
  "use": "icon-nav-editor-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-nav-editor\"><path d=\"M46.08 0v1024h698.88l232.96-232.96V0H46.08z m325.12 573.44l-33.28 30.72-153.6-140.8 153.6-140.8 33.28 30.72L253.44 460.8l117.76 112.64z m94.72 79.36h-46.08L560.64 281.6h46.08l-140.8 371.2z m220.16-48.64l-33.28-30.72 117.76-107.52-117.76-107.52 33.28-30.72 153.6 140.8-153.6 135.68z\" p-id=\"1749\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol